<template>
  <div>
    <div class="row mt-2 mb-2"></div>
    <p class="bb-hdg mt-2 mb-3">Descriptions</p>
    <div class="row mt-2 mb-2">
      <div class="col form-group">
        <div class="form-floating">
          <input
            id="short_description"
            name="short_description"
            :class="[
              'form-control text-left bb-card-short-description-control',
              { 'is-invalid': errorFields.includes('short_description') },
            ]"
            :value="activeItem.short_description"
            placeholder="..."
            maxlength="100"
            @input="onCapitaliseFirstLetter('short_description', $event)"
          />
          <label
            class="bb-float-label optional"
            for="short_description"
            >Short Description</label
          >
        </div>
      </div>
    </div>

    <div class="row mt-2 mb-2">
      <div class="col form-group">
        <div class="form-floating">
          <div class="form-floating">
            <textarea
              id="description"
              name="description"
              type="text"
              rows="4"
              placeholder="..."
              class="form-control bb-textarea-with-label bb-textarea-with-label-compact bb-card-description-control"
              :value="activeItem.description"
              autocomplete="off"
              @input="onDescriptionInput($event)"
            ></textarea>
            <label
              class="bb-float-label optional"
              for="description"
              >Description</label
            >
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-2 mb-2">
      <div class="col form-group">
        <div class="form-floating">
          <div class="form-floating">
            <textarea
              id="dm_notes"
              name="dm_notes"
              type="text"
              rows="4"
              placeholder="..."
              class="form-control bb-textarea-with-label bb-textarea-with-label-compact bb-card-description-control"
              :value="activeItem.dm_notes"
              autocomplete="off"
              @input="onDmNotesInput($event)"
            ></textarea>
            <label
              class="bb-float-label optional"
              for="dm_notes"
              >DM Notes</label
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ItemDescriptionTab',
  props: {
    activeItem: {
      type: Object,
      required: true,
    },
    onCapitaliseFirstLetter: {
      type: Function,
      required: true,
    },
    onDescriptionInput: {
      type: Function,
      required: true,
    },
    onDmNotesInput: {
      type: Function,
      required: true,
    },
    errorFields: {
      type: Array,
      default: () => [],
    },
  },
}
</script>
